/**
 * Auth configuration for the app
 */

export const AUTH_CONFIG = {
	clientName: "tar",
	redirectUri: `${window.location.origin}/auth/callback`,
	scopes: "read write follow push",
	website: window.location.origin,
} as const;
